/* ===========================================================================
   Copper PDP — bundle builder (vanilla JS, Shopify-ready)
   - Reads config from <script type="application/json" class="copper-bundle-config">
   - Renders the build-your-bundle UI, gallery, price, sticky bar
   - Adds multiple line items to the cart via /cart/add.js
   - Applies an optional per-tier discount code via /discount/CODE?redirect=
   Works with any theme. Re-inits on Shopify theme-editor section load.
   ========================================================================== */
(function () {
  "use strict";

  var ICONS = {
    check: '<polyline points="20 6 9 17 4 12"/>',
    star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
    truck: '<path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>',
    award: '<circle cx="12" cy="8" r="6"/><path d="M15.5 13.5 17 22l-5-3-5 3 1.5-8.5"/>',
    gift: '<rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9"/><path d="M12 8v13"/><path d="M12 8S10.5 2 7.5 4 12 8 12 8zM12 8s1.5-6 4.5-4S12 8 12 8z"/>',
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    leaf: '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>',
    droplet: '<path d="M12 2.69 5.5 9.5a7 7 0 1 0 13 0z"/>',
    sparkle: '<path d="M12 3l1.9 5.6L19 10l-5.1 1.4L12 17l-1.9-5.6L5 10l5.1-1.4z"/>',
    chevronDown: '<polyline points="6 9 12 15 18 9"/>',
    chevronLeft: '<polyline points="15 18 9 12 15 6"/>',
    chevronRight: '<polyline points="9 18 15 12 9 6"/>',
    plus: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
    lock: '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
    flame: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>'
  };
  function icon(name, o) {
    o = o || {};
    var size = o.size || 20, fill = o.fill || "none", stroke = o.stroke || "currentColor", sw = o.sw == null ? 1.75 : o.sw;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="' + fill + '" stroke="' + stroke +
      '" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || "") + '</svg>';
  }
  function stars(size, color) {
    size = size || 15; color = color || "var(--gold)";
    var s = "";
    for (var i = 0; i < 5; i++) s += icon("star", { size: size, fill: color, stroke: color, sw: 0 });
    return '<span class="stars">' + s + '</span>';
  }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  /* Shopify money formatter (standard) */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || "${{amount}}";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cs = parts[1] ? decimal + parts[1] : "";
      return dollars + cs;
    }
    var match = fmt.match(placeholder);
    var value = "";
    switch (match ? match[1] : "amount") {
      case "amount": value = withDelimiters(cents, 2); break;
      case "amount_no_decimals": value = withDelimiters(cents, 0); break;
      case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, "."); break;
      case "amount_with_space_separator": value = withDelimiters(cents, 2, " ", "."); break;
      case "amount_no_decimals_with_space_separator": value = withDelimiters(cents, 0, " "); break;
      case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'"); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  }

  /* ── Per-instance controller ─────────────────────────────────────────── */
  function initBundle(root) {
    if (!root || root.__cwbInit) return;
    var cfgEl = root.querySelector(".copper-bundle-config");
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.__cwbInit = true;

    var settings = cfg.settings || {};
    var designs = (cfg.designs || []).filter(function (d) { return d && d.variantId; });
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return (a.slots || 0) - (b.slots || 0); });
    /* gifts may arrive as a newline string (Liquid textarea) or an array */
    tiers.forEach(function (t) {
      if (typeof t.gifts === "string") t.gifts = t.gifts.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      else if (!Array.isArray(t.gifts)) t.gifts = [];
      t.slots = Math.max(1, parseInt(t.slots, 10) || 1);
    });
    var gallery = (cfg.gallery || []).filter(function (g) { return g && g.src; });
    var money = settings.moneyFormat || "${{amount}}";

    var q = function (sel) { return root.querySelector(sel); };

    var notice = q(".cwb-notice");
    if (designs.length === 0 || tiers.length === 0) {
      if (notice) notice.style.display = "block";
      return;
    }
    if (notice) notice.style.display = "none";

    function getDesign(id) { for (var i = 0; i < designs.length; i++) if (designs[i].id === id) return designs[i]; return null; }
    function getDesignByVariant(vid) { for (var i = 0; i < designs.length; i++) if (String(designs[i].variantId) === String(vid)) return designs[i]; return null; }
    function getTier(id) { for (var i = 0; i < tiers.length; i++) if (tiers[i].id === id) return tiers[i]; return tiers[0]; }

    /* default tier: single bottle (lowest slot count) */
    var defaultTier = tiers[0];

    function galleryIndexForDesign(designId) {
      if (!designId) return -1;
      for (var i = 0; i < gallery.length; i++) {
        if (gallery[i].designId === designId) return i;
      }
      return -1;
    }

    function syncGalleryToDesign(designId) {
      var idx = galleryIndexForDesign(designId);
      if (idx < 0) return;
      state.gallery = idx;
      renderGallery();
    }

    /* state */
    var selections = {};
    tiers.forEach(function (t) {
      var arr = [];
      for (var k = 0; k < t.slots; k++) arr.push(designs[k % designs.length].id);
      selections[t.id] = arr;
    });

    var state = { tierId: defaultTier.id, activeSlot: 0, gallery: 0 };
    var initialDesign = (selections[defaultTier.id] || [])[0];
    if (initialDesign) {
      var initialGallery = galleryIndexForDesign(initialDesign);
      if (initialGallery >= 0) state.gallery = initialGallery;
    }

    /* pricing for a tier given its current selection */
    function priceFor(tier) {
      var sel = (selections[tier.id] || []).slice(0, tier.slots);
      var subtotal = 0;
      sel.forEach(function (id) { var d = getDesign(id); if (d) subtotal += d.price; });
      var pct = Math.max(0, Math.min(95, tier.discountPct || 0));
      var discounted = Math.round(subtotal * (1 - pct / 100));
      return {
        subtotal: subtotal,
        total: discounted,
        savings: subtotal - discounted,
        pct: pct,
        perBottle: tier.slots ? Math.round(discounted / tier.slots) : discounted
      };
    }

    /* ── render: gallery ── */
    function renderGallery() {
      var host = q(".js-gallery");
      if (!host) return;
      if (gallery.length === 0) { host.innerHTML = ""; return; }
      if (state.gallery >= gallery.length) state.gallery = 0;
      var g = gallery[state.gallery];
      var thumbs = gallery.map(function (im, idx) {
        return '<button class="thumb ' + (idx === state.gallery ? "thumb--active" : "") +
          '" data-action="gallery" data-i="' + idx + '" aria-label="' + esc(im.alt) + '"><img src="' + esc(im.src) + '" alt="" loading="lazy"></button>';
      }).join("");
      host.innerHTML =
        '<div class="gallery-main"><img src="' + esc(g.src) + '" alt="' + esc(g.alt) + '">' +
        (gallery.length > 1 ?
          '<button class="gallery-nav left" data-action="gallery-prev" aria-label="Previous image">' + icon("chevronLeft", { size: 18, stroke: "var(--copper-deep)" }) + "</button>" +
          '<button class="gallery-nav right" data-action="gallery-next" aria-label="Next image">' + icon("chevronRight", { size: 18, stroke: "var(--copper-deep)" }) + "</button>" : "") +
        (settings.showRating !== false ?
          '<div class="gallery-overlay"><span class="go-left">' + stars(14) + "<span>" + esc(settings.galleryProof || "Loved by thousands") + "</span></span>" +
          '<span class="chip chip--copper" style="font-size:11px">' + icon("shield", { size: 12 }) + " Lab verified</span></div>" : "") +
        "</div>" +
        (gallery.length > 1 ? '<div class="thumbs">' + thumbs + "</div>" : "");
      var activeThumb = host.querySelector(".thumb--active");
      if (activeThumb) {
        try { activeThumb.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" }); } catch (e) { /* ignore */ }
      }
    }

    /* ── render: rating row ── */
    function renderRating() {
      var host = q(".js-rating");
      if (!host) return;
      if (settings.showRating === false) { host.innerHTML = ""; return; }
      host.innerHTML =
        '<span class="rr">' + stars(16) + '<span style="font-weight:700;color:var(--ink);font-size:14px">' + esc(settings.rating || "4.9") + "</span>" +
        '<span style="color:var(--ink-muted);font-size:13px">(' + esc(settings.reviewCount || "verified reviews") + ")</span></span>" +
        '<span class="chip chip--copper">' + icon("check", { size: 12, sw: 3 }) + " Handcrafted</span>" +
        '<span class="chip chip--copper">' + icon("check", { size: 12, sw: 3 }) + " 99.9% Pure Copper</span>";
    }

    /* ── render: builder ── */
    function tiersHTML() {
      return tiers.map(function (t) {
        var active = t.id === state.tierId;
        var p = priceFor(t);
        return '<button class="tier ' + (active ? "tier--active" : "") + '" data-action="tier" data-id="' + esc(t.id) + '" aria-pressed="' + active + '">' +
          (t.badge ? '<span class="tier-badge">' + esc(t.badge) + "</span>" : "") +
          '<span class="tier-radio">' + (active ? icon("check", { size: 13, stroke: "#fff", sw: 3 }) : "") + "</span>" +
          "<div><div class=\"tier-qty\">" + t.slots + " " + (t.slots === 1 ? "Bottle" : "Bottles") + "</div>" +
          '<div class="tier-per">' + formatMoney(p.perBottle, money) + "/bottle</div></div>" +
          '<div><div class="tier-pricerow"><span class="tier-price">' + formatMoney(p.total, money) + "</span>" +
          (p.savings > 0 ? '<span class="tier-orig">' + formatMoney(p.subtotal, money) + "</span>" : "") + "</div>" +
          (p.pct > 0 ? '<div class="tier-save">Save ' + p.pct + "%</div>" : '<div class="tier-save empty">&nbsp;</div>') +
          "</div></button>";
      }).join("");
    }

    function stripHTML(tier) {
      var sel = selections[tier.id] || [];
      var chosen = 0; for (var k = 0; k < tier.slots; k++) if (sel[k]) chosen++;
      var slots = "";
      for (var idx = 0; idx < tier.slots; idx++) {
        var b = getDesign(sel[idx]);
        var active = state.activeSlot === idx;
        slots += '<button class="slot ' + (active ? "slot--active" : "") + '" data-action="slot" data-i="' + idx + '" aria-pressed="' + active + '">' +
          '<span class="slot-thumb">' + (b ? '<img src="' + esc(b.image) + '" alt="' + esc(b.title) + '">' : icon("plus", { size: 20, stroke: "var(--ink-muted)" })) +
          '<span class="slot-num">' + (idx + 1) + "</span></span>" +
          '<span class="slot-label">' + (active ? "Editing" : "Bottle " + (idx + 1)) + "</span></button>";
      }
      return '<div class="strip"><div class="strip-head"><span class="lbl">Your bundle</span>' +
        '<span class="cnt">' + chosen + " of " + tier.slots + " chosen · tap to change</span></div>" +
        '<div class="strip-slots">' + slots + "</div></div>";
    }

    function sliderHTML(tier) {
      var sel = selections[tier.id] || [];
      var activeId = sel[state.activeSlot];
      var slotLabel = tier.slots > 1 ? "Bottle " + (state.activeSlot + 1) : "";
      return '<div class="design-track">' + designs.map(function (b) {
        var selected = activeId === b.id;
        var action = selected
          ? icon("check", { size: 13, sw: 2.5 }) + " Added" + (slotLabel ? " as " + slotLabel : "")
          : "Tap to " + (slotLabel ? "set " + slotLabel : "choose");
        return '<button class="design-card ' + (selected ? "design-card--selected" : "") + '" data-action="design" data-id="' + esc(b.id) + '" aria-pressed="' + selected + '">' +
          '<div class="dc-imgwrap"><img src="' + esc(b.image) + '" alt="' + esc(b.title) + '" loading="lazy">' +
          (b.tag ? '<span class="dc-tag">' + esc(b.tag) + "</span>" : "") +
          '<span class="dc-mark">' + (selected ? icon("check", { size: 14, stroke: "#fff", sw: 3 }) : icon("plus", { size: 14, stroke: "var(--copper-deep)" })) + "</span></div>" +
          '<div class="dc-body"><div class="dc-name">' + esc(b.title) + "</div>" +
          (b.subtitle ? '<div class="dc-sub">' + esc(b.subtitle) + "</div>" : "") +
          '<div class="dc-action">' + action + "</div></div></button>";
      }).join("") + "</div>";
    }

    function nudgeHTML(tier) {
      var idx = -1; for (var i = 0; i < tiers.length; i++) if (tiers[i].id === tier.id) idx = i;
      var next = tiers[idx + 1];
      var p = priceFor(tier);
      if (!next) {
        if (p.savings <= 0) return "";
        return '<div class="nudge nudge--max">' + icon("check", { size: 16, sw: 2.5 }) +
          " You\u2019re getting our biggest saving \u2014 " + formatMoney(p.savings, money) + " off (" + p.pct + "%).</div>";
      }
      var np = priceFor(next);
      return '<div class="nudge nudge--more">' + icon("gift", { size: 17, stroke: "var(--copper)" }) +
        '<span class="txt">Add one more bottle to unlock the <strong style="color:var(--copper-deep)">' + esc(next.label) +
        "</strong> \u2014 save <strong style=\"color:var(--save)\">" + formatMoney(np.savings, money) + "</strong> total.</span></div>";
    }

    function giftsHTML(tier) {
      var gifts = tier.gifts || [];
      if (!gifts.length) return "";
      return '<div class="gifts"><div class="gifts-head">Included free with your order</div>' +
        gifts.map(function (g) { return '<div class="gift-row">' + icon("gift", { size: 14, stroke: "var(--copper)" }) + " " + esc(g) + "</div>"; }).join("") + "</div>";
    }

    function renderBuilder() {
      var tier = getTier(state.tierId);
      if (state.activeSlot > tier.slots - 1) state.activeSlot = tier.slots - 1;
      var host = q(".js-builder");
      if (!host) return;
      host.innerHTML =
        '<div class="builder-head"><div class="step"><span class="step-num">1</span>' +
        '<span class="step-title">Build your bundle</span></div>' +
        (settings.savingsBadge ? '<span class="chip chip--save">' + esc(settings.savingsBadge) + "</span>" : "") + "</div>" +
        '<div class="tiers" data-count="' + tiers.length + '">' + tiersHTML() + "</div>" +
        '<div class="step2"><span class="step-num">2</span><span class="step-title">' +
        (tier.slots === 1 ? "Pick your design" : "Fill your " + tier.slots + " bottles") + "</span></div>" +
        (tier.slots > 1 ? stripHTML(tier) : "") +
        '<div class="choose-row"><span class="choose-label">' +
        (tier.slots === 1 ? "Choose a design" : "Choose a design for Bottle " + (state.activeSlot + 1)) + "</span>" +
        '<span class="swipe-hint">Swipe ' + icon("chevronRight", { size: 13 }) + "</span></div>" +
        sliderHTML(tier) + nudgeHTML(tier) + giftsHTML(tier);
    }

    function renderPrice() {
      var tier = getTier(state.tierId);
      var p = priceFor(tier);
      var host = q(".js-price");
      if (!host) return;
      host.innerHTML =
        '<div class="price-row"><span class="price">' + formatMoney(p.total, money) + "</span>" +
        (p.savings > 0 ? '<span class="price-orig">' + formatMoney(p.subtotal, money) + "</span>" : "") +
        (p.savings > 0 ? '<span class="chip chip--save" style="font-size:13px;padding:5px 12px">You save ' + formatMoney(p.savings, money) + " (" + p.pct + "%)</span>" : "") +
        "</div>" +
        (settings.showUrgency !== false && settings.urgencyText ?
          '<div class="urgency">' + icon("flame", { size: 15, stroke: "var(--copper)", fill: "var(--copper-pale)" }) + " " + esc(settings.urgencyText) + "</div>" : "") +
        '<button class="cta cta--main js-add" data-action="add">' + icon("bag", { size: 20, stroke: "#fff" }) +
        ' Add to Cart \u2014 ' + formatMoney(p.total, money) + "</button>" +
        '<div class="cart-error js-error"></div>' +
        '<div class="secure">' + icon("lock", { size: 13 }) + " Secure checkout \u00b7 " + esc(settings.guaranteeText || "30-day money-back guarantee") + "</div>" +
        '<div class="trust-row">' +
        '<div class="trust-cell">' + icon("shield", { size: 17, stroke: "var(--copper)" }) + "<span>" + esc(settings.trust1 || "30-Day Guarantee") + "</span></div>" +
        '<div class="trust-cell">' + icon("truck", { size: 17, stroke: "var(--copper)" }) + "<span>" + esc(settings.trust2 || "Free Shipping") + "</span></div>" +
        '<div class="trust-cell">' + icon("award", { size: 17, stroke: "var(--copper)" }) + "<span>" + esc(settings.trust3 || "Lifetime Warranty") + "</span></div>" +
        "</div>";
    }

    function renderSticky() {
      var tier = getTier(state.tierId);
      var p = priceFor(tier);
      var sel = (selections[tier.id] || []).slice(0, tier.slots);
      var thumbs = sel.map(function (id) { var b = getDesign(id); return b ? '<img src="' + esc(b.image) + '" alt="' + esc(b.title) + '">' : ""; }).join("");
      var bar = overlay.querySelector(".sticky-bar");
      if (!bar) return;
      bar.innerHTML =
        '<div class="sticky-thumbs">' + thumbs + "</div>" +
        '<div class="sticky-info"><div class="nm">' + esc(tier.label) + "</div>" +
        '<div class="pr"><span class="p">' + formatMoney(p.total, money) + "</span>" +
        (p.savings > 0 ? '<span class="o">' + formatMoney(p.subtotal, money) + "</span>" : "") +
        (p.savings > 0 ? '<span class="s">Save ' + formatMoney(p.savings, money) + "</span>" : "") + "</div></div>" +
        '<button class="cta js-add" data-action="add">' + icon("bag", { size: 18, stroke: "#fff" }) + " <span>Add to Cart</span></button>";
    }

    /* ── overlay (sticky + toast) appended to body so position:fixed is safe ── */
    var overlay = document.createElement("div");
    overlay.className = "cwb cwb-overlay";
    overlay.innerHTML =
      '<div class="sticky-wrap' + (settings.stickyStyle && settings.stickyStyle !== "Floating" ? " sticky-wrap--" + settings.stickyStyle.toLowerCase() : "") + '" aria-hidden="true"><div class="sticky-bar"></div></div>' +
      '<div class="toast-wrap"></div>';
    document.body.appendChild(overlay);
    /* mirror design-token vars from the section root onto the overlay */
    (function () {
      var cs = getComputedStyle(root);
      ["--copper", "--r-lg", "--r-md", "--r-sm", "--gap", "--gap-sm", "--pad"].forEach(function (v) {
        var val = cs.getPropertyValue(v);
        if (val) overlay.style.setProperty(v, val.trim());
      });
    })();

    var stickyWrap = overlay.querySelector(".sticky-wrap");
    var toastWrap = overlay.querySelector(".toast-wrap");

    /* ── behaviour ── */
    function pickTier(id) {
      var nt = getTier(id);
      state.tierId = id;
      var ex = (selections[id] || []).slice();
      while (ex.length < nt.slots) ex.push(designs[ex.length % designs.length].id);
      ex.length = nt.slots;
      selections[id] = ex;
      if (state.activeSlot > nt.slots - 1) state.activeSlot = nt.slots - 1;
      renderBuilder(); renderPrice(); renderSticky();
    }

    function pickDesign(designId) {
      var tier = getTier(state.tierId);
      var arr = (selections[state.tierId] || []).slice();
      arr[state.activeSlot] = designId;
      var next = state.activeSlot, i;
      for (i = state.activeSlot + 1; i < tier.slots; i++) { if (!arr[i]) { next = i; break; } }
      if (next === state.activeSlot) {
        var fe = -1;
        for (i = 0; i < tier.slots; i++) { if (!arr[i]) { fe = i; break; } }
        if (fe !== -1) next = fe; else if (state.activeSlot < tier.slots - 1) next = state.activeSlot + 1;
      }
      state.activeSlot = next;
      selections[state.tierId] = arr;
      syncGalleryToDesign(designId);
      renderBuilder(); renderPrice(); renderSticky();
    }

    var toastTimer = null;
    function showToast(html) {
      toastWrap.innerHTML = '<div class="toast"><span class="ic">' + icon("check", { size: 17, stroke: "#fff", sw: 3 }) + "</span>" +
        '<div style="min-width:0">' + html + "</div></div>";
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastWrap.innerHTML = ""; }, 5000);
    }

    function showError(msg) {
      var el = q(".js-error");
      if (el) { el.textContent = msg; el.classList.add("show"); }
    }
    function clearError() { var el = q(".js-error"); if (el) el.classList.remove("show"); }

    function setLoading(on) {
      root.querySelectorAll(".js-add").forEach(function (b) { b.classList.toggle("is-loading", on); b.disabled = on; });
      overlay.querySelectorAll(".js-add").forEach(function (b) { b.classList.toggle("is-loading", on); b.disabled = on; });
    }

    function updateCartCount(openDrawer) {
      fetch(routeRoot() + "cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.dispatchEvent(new CustomEvent("cwb:cart-updated", { detail: c }));
          // best-effort theme refresh hooks
          document.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: openDrawer ? { open: true } : {}
          }));
        })
        .catch(function () {});
    }

    function addToCart() {
      var tier = getTier(state.tierId);
      var sel = (selections[tier.id] || []).slice(0, tier.slots);
      var counts = {};
      sel.forEach(function (id) {
        var d = getDesign(id);
        if (d && d.variantId) counts[d.variantId] = (counts[d.variantId] || 0) + 1;
      });
      var variantIds = Object.keys(counts);
      if (!variantIds.length) { showError("Please choose your bottle designs first."); return; }

      var props = { "Bundle": tier.label };
      var items = variantIds.map(function (vid) {
        return { id: Number(vid), quantity: counts[vid], properties: props };
      });

      clearError();
      setLoading(true);

      fetch(routeRoot() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          var action = settings.cartAction || "checkout";
          var code = (tier.discountCode || "").trim();

          if (action === "stay") {
            setLoading(false);
            var drawerEnabled = window.MinimogSettings && window.MinimogSettings.enable_cart_drawer;
            updateCartCount(drawerEnabled);
            if (!drawerEnabled) {
              var names = sel.map(function (id) { var d = getDesign(id); return d ? d.title : ""; }).filter(Boolean).join(", ");
              showToast('<div class="t1">Added to cart \u2014 ' + esc(tier.label) + "</div>" +
                '<div class="t2">' + esc(names) + ' \u00b7 <a href="' + routeRoot() + 'cart">View cart</a></div>');
            }
            return;
          }
          updateCartCount();
          var redirect = action === "cart" ? routeRoot() + "cart" : routeRoot() + "checkout";
          if (code) {
            window.location.href = routeRoot() + "discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(redirect);
          } else {
            window.location.href = redirect;
          }
        })
        .catch(function (err) {
          setLoading(false);
          showError((err && (err.description || err.message)) || "Sorry, we couldn't add this bundle. Please try again.");
        });
    }

    /* expose a small API so other sections (e.g. the designs showcase) can preselect */
    if (!window.CopperBundle) window.CopperBundle = {};
    window.CopperBundle.selectVariant = function (vid) {
      var d = getDesignByVariant(vid);
      if (!d) return false;
      var arr = (selections[state.tierId] || []).slice();
      arr[state.activeSlot] = d.id;
      selections[state.tierId] = arr;
      syncGalleryToDesign(d.id);
      renderBuilder(); renderPrice(); renderSticky();
      try { root.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e) { window.scrollTo(0, 0); }
      return true;
    };

    /* ── events (scoped to this root) ── */
    function onClick(e) {
      var t = e.target.closest("[data-action]");
      if (!t || (!root.contains(t) && !overlay.contains(t))) return;
      var a = t.getAttribute("data-action");
      if (a === "tier") pickTier(t.getAttribute("data-id"));
      else if (a === "slot") {
        state.activeSlot = parseInt(t.getAttribute("data-i"), 10) || 0;
        var slotTier = getTier(state.tierId);
        var slotSel = selections[slotTier.id] || [];
        if (slotSel[state.activeSlot]) syncGalleryToDesign(slotSel[state.activeSlot]);
        renderBuilder(); renderPrice(); renderSticky();
      }
      else if (a === "design") pickDesign(t.getAttribute("data-id"));
      else if (a === "gallery") { state.gallery = parseInt(t.getAttribute("data-i"), 10) || 0; renderGallery(); }
      else if (a === "gallery-prev") { state.gallery = (state.gallery - 1 + gallery.length) % gallery.length; renderGallery(); }
      else if (a === "gallery-next") { state.gallery = (state.gallery + 1) % gallery.length; renderGallery(); }
      else if (a === "add") addToCart();
    }
    document.addEventListener("click", onClick);

    function onScroll() {
      var el = q(".js-add");
      if (!el) return;
      var rect = el.getBoundingClientRect();
      var visible = rect.top < window.innerHeight - 40 && rect.bottom > 40;
      var show = window.scrollY > 320 && !visible;
      stickyWrap.classList.toggle("show", show);
      stickyWrap.setAttribute("aria-hidden", show ? "false" : "true");
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    /* cleanup hook for theme editor */
    root.__cwbDestroy = function () {
      document.removeEventListener("click", onClick);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    };

    /* ── init render ── */
    renderGallery(); renderRating(); renderBuilder(); renderPrice(); renderSticky(); onScroll();
  }

  /* showcase "Add to bundle" → preselect in builder if present, else follow link */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-copper-pick]");
    if (!t) return;
    var vid = t.getAttribute("data-copper-pick");
    if (window.CopperBundle && window.CopperBundle.selectVariant) {
      if (window.CopperBundle.selectVariant(vid)) e.preventDefault();
    }
  });

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(".copper-bundle");
    roots.forEach(function (r) { initBundle(r); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify theme editor lifecycle */
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector(".copper-bundle");
    if (r) initBundle(r);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var r = e.target.querySelector(".copper-bundle");
    if (r && r.__cwbDestroy) r.__cwbDestroy();
  });
})();
